export default __webpack_public_path__ + "ac2c7e5331c558d14985381674ba94f0.jpg";